<div *ngIf="showBannerInitially" class="img-wrapper-transition" [class.hiddenBanner]="!showBanner">
  <button type="button" class="close" aria-label="Close" (click)="hideBanner()">
    <span aria-hidden="true"><img src="assets/icons/banner_close.svg" alt="Close the banner"></span>
  </button>
  <img src="assets/images/banner.jpg" class="img-fluid" alt="Banner image" />
</div>
